module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/017-christmas-island-487732b2ed3460d51ca46298f041c20b.svg";